<template>
    <div class="layout mdl-layout mdl-js-layout mdl-layout--fixed-header">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "AppContainer"
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AppContainer.vue